import React, {useEffect, useMemo, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useGetPublisherInvoicesQuery } from '../../../api/publisherInvoiceApiSlice';
import Block from '../../../components/Block';
import { Loader } from '../../../components/components';
import Table from '../../../components/tables/Table';
import useCustomTable from '../../../components/tables/useCustomTable';
import Title from '../../../components/Title';
import {useGetPublisherQuery} from "../../../api/publisherApiSlice";
import Pagination from "../../../components/tables/Pagination";
import * as Format from "../../../components/Format";

const PublisherInvoices = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const publisherId = useParams()["publisherId"];
  const { data: invoices=[], isSuccess, isLoading } = useGetPublisherInvoicesQuery(publisherId)
  const { data: publisher={} } = useGetPublisherQuery({publisherId})
  const tableOptions = {
    sortable: true,
    paginate: true,
    sortBy: {start_date: 'desc'}
  };
  const {
    tableProps,
    paginationProps
  } = useCustomTable(tableOptions)
  const columns = [{
    Header: 'Date',
    accessor: 'start_date',
    sortType: (rowA, rowB, id, desc) => {
      return (new Date(rowA.original.start_date) - new Date(rowB.original.start_date))
    },
    //sortType: 'datetime',
    format: 'date',
    formatOptions: {dateFormat: 'fullMonthYear'}
  },{
    Header: 'Status',
    accessor: 'status',
    Cell: ({row}) => (row.original.final ? t("incomes.final") : t("incomes.draft") )
  },{
    Header: 'Amount',
    accessor: 'amount',
    format: 'price',
    formatOptions: {digits: 2}
  },{
    Header: 'Estimated',
    accessor: 'projected_amount',
    Cell: ({row}) => (row.original.projected_amount ? <Format.Price value={row.original.projected_amount} digits={2}/> : <></>)
  }];

  const invoicesWithDate = useMemo(() => {
    return invoices.map(invoice => ({...invoice, date: new Date(invoice.year, (invoice.month-1), 1)}))
  }, [invoices])

  const onRowClick = (row) => history.push(`${location.pathname}/${row.year}/${row.month}`)
  const onBack = () => history.push(`/publishers/${publisherId}`)

  return ( <>
    <Title main={publisher.name} sub={t('publisher.revenues')} onBack={onBack}/>
    <Block className="mb-0">
      <Loader success={!isLoading && isSuccess} error={!isLoading && !isSuccess}>
        <Table
          data={invoicesWithDate}
          columns={columns}
          onRowClick={onRowClick}
          {...tableProps} />
      </Loader>
    </Block>
    <Pagination {...paginationProps}/>
  </> );
}

export default PublisherInvoices;
